import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Text } from '@/components/GlobalMenu/CopyRight.style';

const CopyRight = ({ footerCopyright }) => (
  <Wrapper>
    <Text>{footerCopyright}</Text>
  </Wrapper>
);

CopyRight.propTypes = {
  footerCopyright: PropTypes.string.isRequired,
};

export default CopyRight;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/CopyRight.js